import React, { useState, useEffect, useContext } from "react";
import "../CSS/dashboard.css";
import {
  getRequestsOfUser,
  deleteRequest,
  changeRequestStatus,
  getCompatibleDonors
} from "../../api/requests";
import AuthContext from "../../context/AuthContext";
import moment from "moment";
import SubmissionForm from "../requests/RequestSubmissionForm";
import { Redirect } from "react-router";
import Swal from "sweetalert2";
import useWindowDimensions from "../utility/windowDimensions";
import { incrementActiveRequestCount, decrementActiveRequestCount } from "../../api/stats";
import Donut from "../ui/donut";

const REQUESTS = 5;
const DAYS = 5;

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-danger mr-2",
    cancelButton: "btn btn-primary ml-2",
  },
  buttonsStyling: false,
});

function RequestCard(props: any) {
  const { width } = useWindowDimensions();
  const [status, setStatus] = useState(props.data.isActive);
  const onSliderChange = (value: boolean) => {
    changeRequestStatus(props.data.requestID, value);
    if (value) incrementActiveRequestCount();
    else decrementActiveRequestCount();
    setStatus(value);
  };
  const [emails, setEmails] = useState(Array);
  // let name = props.data.name;
  // let city = props.data.city;
  // if (width > 1000) {
  //   for (let i = props.data.name.length; i < 20; i++) {
  //     name += " ";
  //   }
  //   for (let i = props.data.city.length; i < 15; i++) {
  //     city += " ";
  //   }
  // }
  const openDeleteConfirmBox = () => {
    swalWithBootstrapButtons
      .fire({
        title: "Delete Request?",
        text: "The request will be permanently deleted.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
      })
      .then((result) => {
        if (result.value) {
          decrementActiveRequestCount();
          deleteRequest(props.data.requestID).then(() =>
            props.updateRequests()
          );
        }
      });
  };

  getCompatibleDonors(props.data.bloodGroup, props.data.city, props.data.type).then((emails) => {
    setEmails(emails);
  });

  return (
    width > 1000 ? 
      <tr className="request-card">
        <td>{props.data.requestID}</td>
        <td>{props.data.name}</td>
        <td>{props.data.contact}</td>
        <td>{props.data.bloodGroup}</td>
        <td>{props.data.city}</td>
        <td>{moment(props.data.date.toDate()).format("MMMM Do YYYY")}</td>
        <td>{props.data.type}</td>
        <td>
          <div className="dashboard-toggle">
          <label className="switch">
            <input
              type="checkbox"
              defaultChecked={props.data.isActive}
              onChange={(event) => onSliderChange(event.target.checked)}
            />
            <span className="slider round">{status ? <p className="dashboard-active-label">Active</p> : <p className="dashboard-inactive-label">Inactive</p>}</span>
          </label>
      </div>
        </td>
        <td>
          <a href={`mailto:?
          &bcc=${emails}
          &subject=Madadgaar%20Blood%20Request
          &body=${props.data.urgency === "Yes" ? "Urgent!" : null}%0D%0A
          ${props.data.bloodGroup}%20${props.data.type}%20required at%20${props.data.hospital}%20${props.data.city}.%0D%0A
          Please%20contact%20${props.data.name}%20on%20+${props.data.contact}%20for%20further%20details.%0D%0A
          Best%20Regards,%0D%0A
          Team%20Madadgaar`} 
          className="btn btn-success ml-2"><i className="fas fa-envelope"></i></a>
        </td>
        <td onClick={() => openDeleteConfirmBox()} className="dashboard-cross-icon">
          <i
            className="far fa-times-circle fa-2x rounded-circle"
            style={{ backgroundColor: "white" }}
          ></i>
        </td>
        {/* <div>
         <div
          className="dashboard-cross-icon"
          onClick={() => openDeleteConfirmBox()}
        >
          <i
            className="far fa-times-circle fa-2x rounded-circle"
            style={{ backgroundColor: "white" }}
          ></i>
        </div>
      </div> */}
      </tr>
      :
    <div className="request-card">
      <div>
        ID:
        {props.data.requestID}
      </div>
      <div>
        Name:
        {props.data.name}
      </div>
      <div>
        Contact No.:
        {`0${props.data.contact.substr(2)}`}
      </div>
      <div>
        Blood Group:
        {props.data.bloodGroup}
      </div>
      <div>
        City:
        {props.data.city}
      </div>
      <div>
        Activation Date:
        {moment(props.data.date.toDate()).format("MMMM Do YYYY")}
      </div>
      <div>
        Request Type:
        {props.data.type}
      </div>

      <div className="dashboard-toggle">
        <label className="switch">
          <input
            type="checkbox"
            defaultChecked={props.data.isActive}
            onChange={(event) => onSliderChange(event.target.checked)}
          />
          <span className="slider round">{status ? <p className="dashboard-active-label">Active</p> : <p className="dashboard-inactive-label">Inactive</p>}</span>
        </label>
      </div>
      <a href={`mailto:?
        &bcc=${emails}
        &subject=Madadgaar%20Blood%20Request
        &body=${props.data.urgency === "Yes" ? "Urgent!" : null}%0D%0A
        ${props.data.bloodGroup}%20${props.data.type}%20required at%20${props.data.hospital}%20${props.data.city}.%0D%0A
        Please%20contact%20${props.data.name}%20on%20+${props.data.contact}%20for%20further%20details.%0D%0A
        Best%20Regards,%0D%0A
        Team%20Madadgaar`} 
        className="btn btn-success ml-2"><i className="fas fa-envelope"></i></a> 
       <div>
         <div
          className="dashboard-cross-icon"
          onClick={() => openDeleteConfirmBox()}
        >
          <i
            className="far fa-times-circle fa-2x rounded-circle"
            style={{ backgroundColor: "white" }}
          ></i>
        </div>
      </div>
    </div>
  );
}

export default function Dashboard() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user }: any = useContext(AuthContext);
  const [numberOfInactiveRequests, setNumberOfInactiveRequests] = useState(0);
  const [numberOfActiveRequests, setNumberOfActiveRequests] = useState(0);
  const labels = ["Active Requests", "Inactive Requests"];
  const { width } = useWindowDimensions();

  // Gets the latest requests from the db and updates state
  const updateRequests = () => {
    if (user && user.userType === "requester") {
      getRequestsOfUser(user.uid).then((data: any) => {
        if (data) {
          data.sort(function (a: any, b: any) {
            return b.date.valueOf() - a.date.valueOf();
          });
          let activeRequests = 0;
          let inactiveRequests = 0;
          for (let i = 0; i < data.length; i++) {
            if (data[i].isActive) {
              activeRequests++;
            } else {
              inactiveRequests++;
            }
          }
          setNumberOfActiveRequests(activeRequests);
          setNumberOfInactiveRequests(inactiveRequests);
          setRequests(
            data.map((request: any, index: number) => (
              <RequestCard
                key={index}
                data={request}
                updateRequests={updateRequests}
              />
            ))
          );
        }
      });
    }
  };

  useEffect(() => {
    updateRequests();
    setTimeout(() => {
      setLoading(false);
    }, 700);
  }, [requests]);

  // Only requester should access this page
  if (user && user.userType !== "requester") {
    return <Redirect to="/" />;
  }

  return (
    <div className="dashboard-outer-div">
      <div id="dashboard-container" className="container">
        <h1 className="dashboard-heading">Dashboard</h1>
        <hr className="horizontal-line"></hr>
        <div>
          <div
            className="modal fade"
            id="dashboard-add-request"
            role="dialog"
            aria-labelledby="dashboard-add-requestLabel"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="dashboard-add-requestLabel">
                    Add Request
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={updateRequests}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <SubmissionForm id="dashboard-submission-inner-container" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dashboard-text-button">
          <h1 className="dashboard-text">Your Requests<br/></h1>
          <Donut series={[numberOfActiveRequests, numberOfInactiveRequests]} labels={labels} showTotal={true} />
          <button
              className="btn"
              id="dashboard-add-request-button"
              data-toggle="modal"
              data-target="#dashboard-add-request"
            >
              Add Request <i className="fas fa-plus-square"></i>
            </button>
        </div>
        <hr className="horizontal-line"/>
        <p className="dashboard-text">
          Remember, you can only make {REQUESTS} requests per day. Requests will be
          deactivated after {DAYS} days. You can reactivate them from here.
        </p>
        <div className="requests-container">
          {loading ? (
            <div
              id="dashboard-inner-loading"
              className="spinner-border text-dark"
              role="status"
            >
              <span className="sr-only">Loading...</span>
            </div>
          ) : requests.length === 0 ?
              <div className="dashboard-text-no-requests"><br /><br /><br />No request found! <br /> You have not made any requests or your requests have been deleted
              </div> : (width > 900 ?
                <div className="table-responsive" id="dashboard-table">
                  <table className="table table-hover">
                    <tbody>{requests}</tbody>
                  </table>
                </div>
                :
                requests
          )}
        </div>
      </div>
    </div>
  );
}
